import React, { useEffect, useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import AppointmentTable from "../components/AppointmentTable";

import { Icon } from "@iconify/react/dist/iconify.js";
import { API_URL } from "..";
import AppointmentStatusTable from "../components/AppointmentStatusTable";
import { useParams } from "react-router-dom";
const AppointmentStatusPage = () => {
    const {status} = useParams();
    const [data,setData]= useState([])
    const fetchAppointments = async () => {
         let headerList = {
           "Accept": "*/*"
        };
        const response = await fetch(
          API_URL+"/api/job/status/"+status,
          { method: "GET", headers: headerList }
        );
        const data = await response.json();
        if (response.status === 200) {
            setData(data.jobs)
            const newJobs = data.jobs.filter(item => item.status === "new").length;
            const activeJobs = data.jobs.filter(item => item.status === "active").length;
            const completedJobs = data.jobs.filter(item => item.status === "completed").length;
            const declinedJobs = data.jobs.filter(item => item.status === "declined").length;
         
        }
      };

      useEffect(()=>{
        fetchAppointments()
      },[1])
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Jobs" />
   
        {/* TableDataLayer */}
        {
            data.length == 0 ? null  : 
        <AppointmentStatusTable data={data} />
        }

      </MasterLayout>

    </>
  );
};

export default AppointmentStatusPage; 
